import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import "./conversations.scss";
import CustomeButton from "../../Button";
import PropTypes from "prop-types";

const ConversationPopup = ({
  visible,
  onConfirm,
  isMessageLoading,
  toggleNotification,
  setToggleNotification,
  setShowConfirmDialog,
  role,
}) => {
  return (
    <Dialog
      visible={visible}
      onHide={() => setShowConfirmDialog(false)}
      header="Post in public conversation?"
      modal
      className="conversation-dialog"
      footer={
        <div className="dialog-footer">
          <div className="notification-wrapper">
            <Checkbox
              inputId="disableNotification"
              checked={toggleNotification}
              onChange={(e) => setToggleNotification(e.checked)}
            />
            <label htmlFor="disableNotification">
              Disable this notification for future messages.
            </label>
          </div>
          <div className="button-wrapper">
            <Button
              label="Cancel"
              onClick={() => setShowConfirmDialog(false)}
              className="cancel-button"
            />
            <CustomeButton
              label="Yes, confirm"
              variant="contained"
              className="send-button"
              iconPos="right"
              onClick={onConfirm}
              loading={isMessageLoading}
            />
          </div>
        </div>
      }
    >
      <p className="dialog-content">
        {["CUSTOMER", "GXM_USER", "GXM_MANAGER", "CUSTOMER_MANAGER"]?.includes(
          role,
        )
          ? "Ensure it contains no sensitive information"
          : "This message will be visible to the customer. Ensure it contains no sensitive information."}
      </p>
    </Dialog>
  );
};
ConversationPopup.propTypes = {
  visible: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isMessageLoading: PropTypes.bool.isRequired,
  toggleNotification: PropTypes.bool.isRequired,
  setToggleNotification: PropTypes.func.isRequired,
  setShowConfirmDialog: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};

export default ConversationPopup;
